/* eslint-disable */
import {
  Button,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Box } from "@mui/system";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import CheckIcon from "@mui/icons-material/Check";
import { useEffect, useState } from "react";
import { getLPLenteDeContacto } from "../../../project/services/LenteContactoService";
import { isEmptyObject } from "../../../project/utils/utils";
import Message from "../../../project/utils/Message";
import WaitingDialog from "../../utils/WaitingDialog";

const initialState = {
  curva: "",
  diametro: "",
  adicion: "",
};

const initialFilterState = {
  esfera: "",
  cilindro: "",
  eje: "",
};
//
// ################################################################################
//
const ListaPrecioLenteContacto = ({ idLpLentesContacto, onSelectCorreccion, onClose }) => {
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [lpLenteContacto, setLPLenteContacto] = useState({});
  const [rangoLPLenteContacto, setRangoLPLenteContacto] = useState({});
  const [rangoLPLenteContactoCorrecciones, setRangoLPLenteContactoCorrecciones] = useState([]);
  const [showLPLenteContacto, setShowLPLenteContacto] = useState(true);
  const [showCorreccionesExistentes, setShowCorreccionesExistentes] = useState(false);
  const [itemData, setItemData] = useState(initialState);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [filter, setFilter] = useState(initialFilterState);
  const [totalRowsCount, setTotalRowsCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const adicionOptions = [
    {
      id: "low",
      descripcion: "Low",
    },
    {
      id: "med",
      descripcion: "Med",
    },
    {
      id: "high",
      descripcion: "High",
    },
  ];

  const tableColumnsRango = [
    {
      field: "esfera_desde",
      headerName: "Esf Desde",
      headerAlign: "center",
      align: "center",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.esfera_desde.toFixed(2);
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "esfera_hasta",
      headerName: "Esf Hasta",
      headerAlign: "center",
      align: "center",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.esfera_hasta.toFixed(2);
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "cilindro_desde",
      headerName: "Cil Desde",
      headerAlign: "center",
      align: "center",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cilindro_desde.toFixed(2);
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "cilindro_hasta",
      headerName: "Cil Hasta",
      headerAlign: "center",
      align: "center",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cilindro_hasta.toFixed(2);
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "precio_venta_contado",
      headerName: "PV Contado",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.precio_venta_contado.toFixed(2);
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "precio_venta_lista",
      headerName: "PV Lista",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.precio_venta_lista.toFixed(2);
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "cantidad_correcciones",
      headerName: "Cant Corr",
      headerAlign: "center",
      align: "center",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.correcciones_list.length;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          <Tooltip title="ver correcciones existentes">
            <IconButton
              size="small"
              aria-label="update"
              onClick={() => verCorreccionesExistentes(params.row)}
            >
              <RemoveRedEyeOutlinedIcon />
            </IconButton>
          </Tooltip>
        </>
      ),
    },
  ];

  const tableOptionsRango = {
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };

  const tableColumnsCorreccion = [
    {
      field: "esfera",
      headerName: "Esfera",
      headerAlign: "center",
      align: "center",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.esfera.toFixed(2);
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "cilindro",
      headerName: "Cilindro",
      headerAlign: "center",
      align: "center",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cilindro.toFixed(2);
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "eje",
      headerName: "Eje",
      headerAlign: "center",
      align: "center",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.eje;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          <Tooltip title="seleccionar corrección">
            <IconButton
              size="small"
              aria-label="update"
              onClick={() => seleccionarCorreccion(params.row)}
            >
              <CheckIcon />
            </IconButton>
          </Tooltip>
        </>
      ),
    },
  ];

  const tableOptionsCorreccion = {
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    const load = async () => {
      setIsDoingSomething(true);
      const response = await getLPLenteDeContacto(idLpLentesContacto);
      setIsDoingSomething(false);

      if (response.ok) {

        console.log('------------------------------');
        console.log('im in listapreciolentecontacto');
        console.log('response.data.data');
        console.log(response.data.data);
        console.log('------------------------------');

        let _lpLenteContacto = response.data.data;

        let _curvas = "";
        _lpLenteContacto.curvas_list.forEach((element) => {
          _curvas += element.valor_lc_curva + " ";
        });
        _lpLenteContacto.curvas = _curvas;

        let _diametros = "";
        _lpLenteContacto.diametros_list.forEach((element) => {
          _diametros += element.valor_lc_diametro + " ";
        });
        _lpLenteContacto.diametros = _diametros;

        setLPLenteContacto(_lpLenteContacto);
      } else {
        setMessage({
          messageText: response.messageText,
          severity: response.messageSeverity,
        });
        setShowMessage(true);
      }
    };

    load();
  }, []);
  //
  // ################################################################################
  //
  const verCorreccionesExistentes = (parRow) => {
    parRow.curvas = lpLenteContacto.curvas_list;
    parRow.diametros = lpLenteContacto.diametros_list;
    setRangoLPLenteContacto(parRow);
    setRangoLPLenteContactoCorrecciones(parRow.correcciones_list);
    setShowLPLenteContacto(false);
    setShowCorreccionesExistentes(true);
  };
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    if (showCorreccionesExistentes) {
      setShowLPLenteContacto(true);
      setShowCorreccionesExistentes(false);
    } else {
      onClose();
    }
  };
  //
  // ################################################################################
  //
  const seleccionarCorreccion = (parCorreccionSelected) => {
    if (itemData.curva === "" || itemData.diametro === "") {
      setMessage({
        severity: "error",
        messageText: "Debes seleccionar una curva y un diámetro",
      });
      setShowMessage(true);
      return;
    }

    if (lpLenteContacto.multifocal_lente_contacto_producto && itemData.adicion === "") {
      setMessage({
        severity: "error",
        messageText: "Debes seleccionar una adición",
      });
      setShowMessage(true);
      return;
    }

    parCorreccionSelected.id_lente_contacto_producto = lpLenteContacto.id_lente_contacto_producto;
    parCorreccionSelected.descripcion_lente_contacto_producto =
      lpLenteContacto.descripcion_lente_contacto_producto;
    parCorreccionSelected.multifocal_lente_contacto_producto =
      lpLenteContacto.multifocal_lente_contacto_producto;
    parCorreccionSelected.descripcion_lc_presentacion = lpLenteContacto.descripcion_lc_presentacion;
    parCorreccionSelected.venta_por_unidad = lpLenteContacto.venta_por_unidad;
    parCorreccionSelected.id_lc_presentacion = lpLenteContacto.id_lc_presentacion;
    parCorreccionSelected.id_lc_lprecio = idLpLentesContacto;
    parCorreccionSelected.id_lc_curva = itemData.curva;
    parCorreccionSelected.valor_lc_curva = lpLenteContacto.curvas_list.find(
      (item) => item.id_lc_curva === itemData.curva
    ).valor_lc_curva;
    parCorreccionSelected.id_lc_diametro = itemData.diametro;
    parCorreccionSelected.valor_lc_diametro = lpLenteContacto.diametros_list.find(
      (item) => item.id_lc_diametro === itemData.diametro
    ).valor_lc_diametro;
    parCorreccionSelected.adicion = itemData.adicion;
    parCorreccionSelected.costo_pesos = rangoLPLenteContacto.costo_pesos;
    parCorreccionSelected.precio_venta_contado = rangoLPLenteContacto.precio_venta_contado;
    parCorreccionSelected.precio_venta_lista = rangoLPLenteContacto.precio_venta_lista;
    onSelectCorreccion(parCorreccionSelected);
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setItemData({
      ...itemData,
      [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeFilter = (e) => {

    setFilter({
      ...filter,
      [e.target.name]: e.target.value,
    });
  };
  //
  // ################################################################################
  //
  useEffect(() => {

    let _Filtered = rangoLPLenteContacto.correcciones_list || [];

    if (filter.esfera || filter.cilindro || filter.eje) {
      // si hay filtro para esfera o para cilindro o para eje

      _Filtered = rangoLPLenteContacto.correcciones_list.filter(
        (item) => {

          let _esferaOk = false;
          let _cilindroOk = false;
          let _ejeOk = false;

          if (!filter.esfera) {
            // si no hay filtro de esfera
            _esferaOk = true;
          } else {
            // si hay filtro de esfera
            if (item.esfera.toString().includes(filter.esfera)) {
              _esferaOk = true;
            }
          }

          if (!filter.cilindro) {
            // si no hay filtro de cilindro
            _cilindroOk = true;
          } else {
            // si hay filtro de cilindro
            if (item.cilindro.toString().includes(filter.cilindro)) {
              _cilindroOk = true;
            }
          }

          if (!filter.eje) {
            // si no hay filtro de eje
            _ejeOk = true;
          } else {
            // si hay filtro de eje
            if (item.eje.toString().includes(filter.eje)) {
              _ejeOk = true;
            }
          }

          return _esferaOk && _cilindroOk && _ejeOk;
        }
      );
    }
    setRangoLPLenteContactoCorrecciones(_Filtered);
    setTotalRowsCount(_Filtered.length);
    setCurrentPage(Math.round(_Filtered.length / rowsPerPage));
  }, [filter]);
  //
  // ################################################################################
  //
  return (
    <>
      {showLPLenteContacto && !isEmptyObject(lpLenteContacto) && (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box p={2}>
              <Grid container spacing={1}>
                {/* producto */}
                <Grid item xs={4}>
                  <TextField
                    sx={{ width: "100%" }}
                    id="descripcion_lente_contacto_producto"
                    label="Producto"
                    variant="outlined"
                    size="small"
                    name="descripcion_lente_contacto_producto"
                    value={lpLenteContacto.descripcion_lente_contacto_producto}
                    disabled
                    fullWidth
                  />
                </Grid>

                {/* marca */}
                <Grid item xs={4}>
                  <TextField
                    sx={{ width: "100%" }}
                    id="descripcion_lc_marca"
                    label="Marca"
                    variant="outlined"
                    size="small"
                    name="descripcion_lc_marca"
                    value={lpLenteContacto.descripcion_lc_marca}
                    disabled
                    fullWidth
                  />
                </Grid>

                {/* submarca */}
                <Grid item xs={4}>
                  <TextField
                    sx={{ width: "100%" }}
                    id="descripcion_lc_submarca"
                    label="Submarca"
                    variant="outlined"
                    size="small"
                    name="descripcion_lc_submarca"
                    value={lpLenteContacto.descripcion_lc_submarca}
                    disabled
                    fullWidth
                  />
                </Grid>

                {/* diagnostico */}
                <Grid item xs={4}>
                  <TextField
                    sx={{ width: "100%" }}
                    id="descripcion_lc_diagnostico"
                    label="Diagnóstico"
                    variant="outlined"
                    size="small"
                    name="descripcion_lc_diagnostico"
                    value={lpLenteContacto.descripcion_lc_diagnostico}
                    disabled
                    fullWidth
                  />
                </Grid>

                {/* material */}
                <Grid item xs={4}>
                  <TextField
                    sx={{ width: "100%" }}
                    id="descripcion_lc_material"
                    label="Material"
                    variant="outlined"
                    size="small"
                    name="descripcion_lc_material"
                    value={lpLenteContacto.descripcion_lc_material}
                    disabled
                    fullWidth
                  />
                </Grid>

                {/* tiempo de uso */}
                <Grid item xs={4}>
                  <TextField
                    sx={{ width: "100%" }}
                    id="descripcion_lc_tiempo_uso"
                    label="Tiempo de uso"
                    variant="outlined"
                    size="small"
                    name="descripcion_lc_tiempo_uso"
                    value={lpLenteContacto.descripcion_lc_tiempo_uso}
                    disabled
                    fullWidth
                  />
                </Grid>

                {/* tipo */}
                <Grid item xs={4}>
                  <TextField
                    sx={{ width: "100%" }}
                    id="descripcion_lc_tipo"
                    label="Tipo"
                    variant="outlined"
                    size="small"
                    name="descripcion_lc_tipo"
                    value={lpLenteContacto.descripcion_lc_tipo}
                    disabled
                    fullWidth
                  />
                </Grid>

                {/* color */}
                <Grid item xs={4}>
                  <TextField
                    sx={{ width: "100%" }}
                    id="descripcion_lc_color"
                    label="Color"
                    variant="outlined"
                    size="small"
                    name="descripcion_lc_color"
                    value={lpLenteContacto.descripcion_lc_color}
                    disabled
                    fullWidth
                  />
                </Grid>

                {/* presentacion */}
                <Grid item xs={4}>
                  <TextField
                    sx={{ width: "100%" }}
                    id="descripcion_lc_presentacion"
                    label="Presentación"
                    variant="outlined"
                    size="small"
                    name="descripcion_lc_presentacion"
                    value={lpLenteContacto.descripcion_lc_presentacion}
                    disabled
                    fullWidth
                  />
                </Grid>

                {/* multifocal */}
                <Grid item xs={2}>
                  <TextField
                    sx={{ width: "100%" }}
                    id="multifocal_lente_contacto_producto"
                    label="Multifocal"
                    variant="outlined"
                    size="small"
                    name="multifocal_lente_contacto_producto"
                    value={lpLenteContacto.multifocal_lente_contacto_producto ? "Sí" : "No"}
                    disabled
                    fullWidth
                  />
                </Grid>

                {/* venta por unidad */}
                <Grid item xs={2}>
                  <TextField
                    sx={{ width: "100%" }}
                    id="venta_por_unidad"
                    label="Se vende por unidad"
                    variant="outlined"
                    size="small"
                    name="venta_por_unidad"
                    value={lpLenteContacto.venta_por_unidad ? "Sí" : "No"}
                    disabled
                    fullWidth
                  />
                </Grid>

                {/* curvas */}
                <Grid item xs={4}>
                  <TextField
                    sx={{ width: "100%" }}
                    id="curvas"
                    label="Curvas"
                    variant="outlined"
                    size="small"
                    name="curvas"
                    value={lpLenteContacto.curvas}
                    disabled
                    fullWidth
                  />
                </Grid>

                {/* diametros */}
                <Grid item xs={4}>
                  <TextField
                    sx={{ width: "100%" }}
                    id="diametros"
                    label="Diámetros"
                    variant="outlined"
                    size="small"
                    name="diametros"
                    value={lpLenteContacto.diametros}
                    disabled
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12}>
                  <DataGrid
                    rows={lpLenteContacto.rangos_list}
                    columns={tableColumnsRango}
                    {...tableOptionsRango}
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      )}

      {showCorreccionesExistentes && (
        <>
          <Box p={2}>
            <Grid container spacing={1}>
              {/* esfera desde */}
              <Grid item xs={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    style: { textAlign: "center" },
                  }}
                  id="esfera_desde"
                  label="Esf Desde"
                  variant="outlined"
                  size="small"
                  name="esfera_desde"
                  value={rangoLPLenteContacto.esfera_desde.toFixed(2)}
                  disabled
                  fullWidth
                />
              </Grid>

              {/* esfera hasta */}
              <Grid item xs={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    style: { textAlign: "center" },
                  }}
                  id="esfera_hasta"
                  label="Esf Hasta"
                  variant="outlined"
                  size="small"
                  name="esfera_hasta"
                  value={rangoLPLenteContacto.esfera_hasta.toFixed(2)}
                  disabled
                  fullWidth
                />
              </Grid>

              {/* cilindro desde */}
              <Grid item xs={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    style: { textAlign: "center" },
                  }}
                  id="cilindro_desde"
                  label="Cil Desde"
                  variant="outlined"
                  size="small"
                  name="cilindro_desde"
                  value={rangoLPLenteContacto.cilindro_desde.toFixed(2)}
                  disabled
                  fullWidth
                />
              </Grid>

              {/* cilindro hasta */}
              <Grid item xs={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    style: { textAlign: "center" },
                  }}
                  id="cilindro_hasta"
                  label="Cil Hasta"
                  variant="outlined"
                  size="small"
                  name="cilindro_hasta"
                  value={rangoLPLenteContacto.cilindro_hasta.toFixed(2)}
                  disabled
                  fullWidth
                />
              </Grid>

              {/* precio de venta de contado */}
              <Grid item xs={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    style: { textAlign: "center" },
                  }}
                  id="precio_venta_contado"
                  label="PV Contado"
                  variant="outlined"
                  size="small"
                  name="precio_venta_contado"
                  value={rangoLPLenteContacto.precio_venta_contado}
                  disabled
                  fullWidth
                />
              </Grid>

              {/* precio de venta de lista */}
              <Grid item xs={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    style: { textAlign: "center" },
                  }}
                  id="precio_venta_lista"
                  label="PV Lista"
                  variant="outlined"
                  size="small"
                  name="precio_venta_lista"
                  value={rangoLPLenteContacto.precio_venta_lista}
                  disabled
                  fullWidth
                />
              </Grid>

              {/* curvas */}
              <Grid item xs={2}>
                <FormControl fullWidth>
                  <InputLabel id="curva-select-label">Curva base</InputLabel>
                  <Select
                    labelId="curva-select-label"
                    id="curva-select"
                    name="curva"
                    value={itemData.curva}
                    label="Curva base"
                    size="small"
                    onChange={handleChange}
                    MenuProps={{ style: { maxHeight: "300px" } }}
                  >
                    {rangoLPLenteContacto.curvas.map((item) => (
                      <MenuItem key={item.id_lc_curva} value={item.id_lc_curva}>
                        {item.valor_lc_curva}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {/* diametros */}
              <Grid item xs={2}>
                <FormControl fullWidth>
                  <InputLabel id="diametro-select-label">Diámetro</InputLabel>
                  <Select
                    labelId="diametro-select-label"
                    id="diametro-select"
                    name="diametro"
                    value={itemData.diametro}
                    label="Diámetro"
                    size="small"
                    onChange={handleChange}
                    MenuProps={{ style: { maxHeight: "300px" } }}
                  >
                    {rangoLPLenteContacto.diametros.map((item) => (
                      <MenuItem key={item.id_lc_diametro} value={item.id_lc_diametro}>
                        {item.valor_lc_diametro}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {lpLenteContacto.multifocal_lente_contacto_producto && (
                <Grid item xs={2}>
                  <FormControl fullWidth>
                    <InputLabel id="adicion-select-label">adicion</InputLabel>
                    <Select
                      labelId="adicion-select-label"
                      id="adicion-select"
                      name="adicion"
                      value={itemData.adicion}
                      label="Adición"
                      size="small"
                      onChange={handleChange}
                      MenuProps={{ style: { maxHeight: "300px" } }}
                    >
                      {adicionOptions.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.descripcion}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}

              {/* componentes para buscar correcciones existentes */}

              <Grid item xs={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    style: { textAlign: "center", autoComplete: "off" },
                  }}
                  id="esfera"
                  label="Esfera"
                  variant="outlined"
                  size="small"
                  name="esfera"
                  value={filter.esfera}
                  onChange={handleChangeFilter}
                  fullWidth
                />
              </Grid>

              <Grid item xs={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    style: { textAlign: "center", autoComplete: "off" },
                  }}
                  id="cilindro"
                  label="Cilindro"
                  variant="outlined"
                  size="small"
                  name="cilindro"
                  value={filter.cilindro}
                  onChange={handleChangeFilter}
                  fullWidth
                />
              </Grid>

              <Grid item xs={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    style: { textAlign: "center", autoComplete: "off" },
                  }}
                  id="eje"
                  label="Eje"
                  variant="outlined"
                  size="small"
                  name="eje"
                  value={filter.eje}
                  onChange={handleChangeFilter}
                  fullWidth
                />
              </Grid>
            </Grid>
          </Box>
          <Box p={2}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <DataGrid
                  rows={rangoLPLenteContactoCorrecciones}
                  columns={tableColumnsCorreccion}
                  {...tableOptionsCorreccion}
                />
              </Grid>
            </Grid>
          </Box>
        </>
      )}

      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Box sx={{ mt: 2, float: "right" }}>
            <Button variant="contained" color="primary" onClick={handleCloseDialog}>
              Cerrar
            </Button>
          </Box>
        </Grid>
      </Grid>

      {/* >>>> Messages */}

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default ListaPrecioLenteContacto;
